namespace Controlli {
    export namespace FormAside {

        let sidebar;
        let titolo;
        let corpo;
        let buttonclose;
        let _panelColonneBarracharmSecondary;

        let _dimensione: string;

        export let IsOpen: boolean;

        export function Initialize() {
            //get object
            sidebar = $("[data-barracharm]");
            titolo = $("[data-barracharm-titolo");
            corpo = $("[data-barracharm-corpo]");
            buttonclose = $("[data-barracharm-close]");

            _panelColonneBarracharmSecondary = $("[data-barracharm-secondary]")

            //Set Transition
            sidebar.show(0, function () {
                sidebar.css('transition', 'all 0.5s ease');
            });

            //Set Handlers
            $(document).on("Overlay_HideEvent", () => Hide());

            buttonclose.on("click", (e: JQuery.Event) => { e.preventDefault(); Hide() });

            InitializeSecondary();
        }

        export function Show() {
            IsOpen = true;
            sidebar.css('margin-right', '0');
            sidebar.css('width', _dimensione);

            Overlay.Show(false);
        }


        export function Hide();
        export function Hide(RefreshPartial: boolean);
        export function Hide(RefreshPartial?: boolean) {
            if (IsOpen) {
                sidebar.css('margin-right', "-" + _dimensione);
                titolo.html("");
                if (RefreshPartial != null && !RefreshPartial) {
                    Utility.DestroyControl(corpo);
                    corpo.html("");
                }

                _panelColonneBarracharmSecondary.css('margin-right', "-1000px");
            }

            IsOpen = false;
            Overlay.Hide(false);
        }

        function SetDimension(_option: string) {
            let _schermo = $(document).width();

            switch (CharmDimensions[_option]) {
                case CharmDimensions.ExtraSmall:
                    _dimensione = (Math.round((200 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Small:
                    _dimensione = (Math.round((400 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Medium:
                    _dimensione = (Math.round((600 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Large:
                    _dimensione = (Math.round((800 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.ExtraLarge:
                    _dimensione = (Math.round((1000 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Fullscreen:
                    _dimensione = _schermo + "px";
                    break;
                default:
                    _dimensione = (Math.round((600 * _schermo) / 1900)).toString() + "px";
                    break;
            }
        }

        export function Load(_options: CharmOptions) {
            titolo.html(_options.Titolo);
            Ajax.AjaxLoadingHTML(_options.Url, "[data-barracharm-corpo]", _options.UrlData);
            SetDimension(_options.Dimensione.toString());
            Show();
        }

        //Return from controller
        export function AjaxFormCharmOnBegin() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */ }
        export function AjaxFormCharmOnComplete(result) {
            let _data: Ajax.FormJsonResult = result.responseJSON;

            switch (_data.Stato) {
                case Ajax.StatoForm.OK:
                    corpo.html(_data.PartialView);
                    Utility.RefreshControl(corpo);
                    Hide();
                    break;
                case Ajax.StatoForm.OK_Apri:
                case Ajax.StatoForm.Errore_Model:
                case Ajax.StatoForm.Errore:
                    corpo.html(_data.PartialView);
                    Utility.RefreshControl(corpo);
                    break;
                case Ajax.StatoForm.OK_Redirect:
                    Hide();
                    Ajax.AjaxRedirectToAction(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshBody:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshTarget:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url, _data.TargetID);
                    break;
                case Ajax.StatoForm.OK_RefreshPartial:
                    Hide(true);
                    $("#" + _data.TargetID).html(_data.PartialView);
                    Utility.RefreshControl("#" + _data.TargetID);
                    break;
                case Ajax.StatoForm.OK_Chiudi:
                    Hide();
                    break;
                case Ajax.StatoForm.Undefined:
                    break;
            }
        }
        export function AjaxFormCharmOnSuccess() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */  }
        export function AjaxFormCharmOnFailure() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */ }

        export class CharmOptions {
            Url: string;
            UrlData: object;
            Titolo: string;
            Dimensione: CharmDimensions;

            constructor() {
                this.Titolo = "Titolo View";
                this.Dimensione = CharmDimensions.Medium
            }
        }

        export enum CharmDimensions {
            ExtraSmall,
            Small,
            Medium,
            Large,
            ExtraLarge,
            Fullscreen
        }

        let sidebarSecondary;
        let titoloSecondary;
        let corpoSecondary;
        let buttoncloseSecondary;

        let _dimensioneSecondary: string;

        export var IsOpenSecondary: boolean;
        export var IsOpenSecondary: boolean;

        export function InitializeSecondary() {
            //get object
            sidebarSecondary = $("[data-barracharm-secondary]");
            titoloSecondary = $("[data-barracharm-secondary-titolo");
            corpoSecondary = $("[data-barracharm-secondary-corpo]");
            buttoncloseSecondary = $("[data-barracharm-secondary-close]");

            //Set Transition
            sidebarSecondary.show(0, function () {
                sidebarSecondary.css('transition', 'all 0.5s ease');
            });

            //Set Handlers
            $(document).on("Overlay_HideEvent", () => HideSecondary());

            buttoncloseSecondary.on("click", (e: JQuery.Event) => { e.preventDefault(); HideSecondary() });
        }
        export function LoadSecondary(_options: CharmOptions) {
            titoloSecondary.html(_options.Titolo);
            Ajax.AjaxLoadingHTML(_options.Url, "[data-barracharm-secondary-corpo]", _options.UrlData);
            SetDimensionSecondary(_options.Dimensione.toString());
            ShowSecondary();

        }
        function SetDimensionSecondary(_option: string) {
            let _schermo = $(document).width();

            switch (CharmDimensions[_option]) {
                case CharmDimensions.ExtraSmall:
                    _dimensioneSecondary = (Math.round((200 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Small:
                    _dimensioneSecondary = (Math.round((400 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Medium:
                    _dimensioneSecondary = (Math.round((600 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Large:
                    _dimensioneSecondary = (Math.round((800 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.ExtraLarge:
                    _dimensioneSecondary = (Math.round((1000 * _schermo) / 1900)).toString() + "px";
                    break;
                case CharmDimensions.Fullscreen:
                    _dimensioneSecondary = _schermo + "px";
                    break;
                default:
                    _dimensioneSecondary = (Math.round((600 * _schermo) / 1900)).toString() + "px";
                    break;
            }
        }
        export function ShowSecondary() {
            IsOpenSecondary = true;
            if (IsOpen)
                sidebarSecondary.css('margin-right', _dimensione);
            else {
                sidebarSecondary.css('margin-right', 0);
                Overlay.Show(false);
            }
            sidebarSecondary.css('width', _dimensioneSecondary);
        }
        export function HideSecondary() {
            if (IsOpenSecondary) {
                if (IsOpen) {
                    sidebarSecondary.css('margin-right', "-" + _dimensione);
                }
                else {
                    sidebarSecondary.css('margin-right', "-" + _dimensioneSecondary);
                    Controlli.Overlay.Hide(false);
                }
                titoloSecondary.html("");
                Utility.DestroyControl(corpoSecondary);
                corpoSecondary.html("");
            }

            IsOpenSecondary = false;
        }


        export function AjaxFormCharmSecondaryOnBegin() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */ }
        export function AjaxFormCharmSecondaryOnComplete(result) {
            let _data: Ajax.FormJsonResult = result.responseJSON;

            switch (_data.Stato) {
                case Ajax.StatoForm.OK:
                    corpoSecondary.html(_data.PartialView);
                    Utility.RefreshControl(corpoSecondary);
                    Hide();

                    break;
                case Ajax.StatoForm.OK_Apri:
                case Ajax.StatoForm.Errore_Model:
                case Ajax.StatoForm.Errore:
                    corpoSecondary.html(_data.PartialView);
                    Utility.RefreshControl(corpoSecondary);

                    break;
                case Ajax.StatoForm.OK_Redirect:
                    Hide();
                    Ajax.AjaxRedirectToAction(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshBody:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url);
                    break;
                case Ajax.StatoForm.OK_RefreshTarget:
                    Hide();
                    Ajax.AjaxLoadingHTML(_data.Url, _data.TargetID);
                    break;

                case Ajax.StatoForm.Undefined:
                    break;
            }
        }
        export function AjaxFormCharmSecondaryOnSuccess() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */  }
        export function AjaxFormCharmSecondaryOnFailure() { /* document why this function 'AjaxFormCharmSecondaryOnSuccess' is empty */ }
    }
}